import { batch } from 'react-redux';
import { externalUploadPoller } from '@ff-os/pdp-shared-redux/apis/external-upload/externalUploaderPoller';
import { loadFonts } from '@ff-os/pdp-shared-redux/apis/fonts/loadFonts';
import { initializeExportMonitor } from '@ff-os/pdp-shared-redux/ExportMonitor';
import { actions as globalActions, DisplayMode, Language } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';

export const startup = (
    store: PdpStore,
    language: Language,
    displayMode: DisplayMode
) => {

    batch(() => {
        store.dispatch(globalActions.setLanguage(language));
        store.dispatch(globalActions.setDisplayMode(displayMode));
    });

    externalUploadPoller.activate(store.getState, store.dispatch, { msInterval: 5000 });
    initializeExportMonitor(store);
    store.dispatch(loadFonts());

    const state = store.getState();
    scenePlugins
        .require(state.scene.pluginId)
        .startup(store);
};